import { OPERATOR } from '../../../../../interfaces/enums';
import { Selectable } from '../../../../DunningSelectionPage/DunningSelection/input/InputInterfaces';
import { Validator } from '../../../../DunningSelectionPage/DunningSelection/input/Validators';
import { RuleConditionInputDefinition, RuleConditionInputTypes } from '../RuleCondition/RuleConditionTypes';
import {
  RuleDefinitionOperatorValue,
  RuleDefinitionValue,
  ruleDefinitionValueFrom,
} from '../RuleCondition/RuleInputs/RuleDefinitionBaseProps';

export function conditionArgumentAccessors<T extends { argument: any }>() {
  return {
    getter: (obj: T) => ruleDefinitionValueFrom(obj.argument),
    setter: (obj: T, val: RuleDefinitionValue) => (obj.argument = val.toRuleArgument()),
  };
}

export const operatorSelect: (limitedOperator?: OPERATOR[]) => RuleConditionInputDefinition = limitedOperator => ({
  type: RuleConditionInputTypes.OPERATOR,
  getter: (obj: { cmp?: OPERATOR }) => new RuleDefinitionOperatorValue(obj.cmp ?? OPERATOR.EQ),
  setter: (obj: { cmp?: OPERATOR }, val: RuleDefinitionValue) => (obj.cmp = val.toValue()),
  inputProps: {
    availableOperators: limitedOperator,
  },
});

export const defaultInput: (
  type: RuleConditionInputTypes,
  validators?: Validator[],
  selectables?: Selectable[],
  computedProperties?: Array<{ key: any; label: string }>,
  allowNegativeValues?: boolean,
) => RuleConditionInputDefinition = (type, validators, selectables, computedProperties, allowNegativeValues) => ({
  type,
  ...conditionArgumentAccessors(),
  validators,
  selectables,
  computedProperties,
  allowNegativeValues,
});
